(function () {
  if (window.SCCAddonCartGuard) return;

  var nativeFetch = window.fetch.bind(window);
  var pendingCount = 0;
  var syncPromise = null;
  var checkoutRunning = false;

  var CASE_VARIANTS = {
    pink: 48451109716209,
    white: 48451109847281,
    purple: 48451109748977,
    green: 48451109781745,
    black: 48451109814513
  };
  var CASE_VARIANT_IDS = Object.keys(CASE_VARIANTS).map(function (key) { return CASE_VARIANTS[key]; });
  var WHITENING_VARIANT_ID = 46176431702257;
  var EXPEDITE_VARIANT_ID = 46309636899057;
  var ADDON_VARIANT_IDS = CASE_VARIANT_IDS.concat([WHITENING_VARIANT_ID, EXPEDITE_VARIANT_ID]);

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function lower(value) {
    return String(value || '').toLowerCase();
  }

  function isCartAddUrl(input) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (!url) return false;
    return /\/cart\/add(\.js)?(?:\?|$)/.test(url);
  }

  function isCartChangeUrl(input) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (!url) return false;
    return /\/cart\/change(\.js)?(?:\?|$)/.test(url);
  }

  function isPost(input, init) {
    return lower((init && init.method) || (input && input.method) || 'GET') === 'post';
  }

  function selectedCaseColorName(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (/original|blue|included|\$0/i.test(raw) && /blue/i.test(raw)) return '';
    var match = raw.match(/pink|white|purple|green|black/i);
    return match ? match[0].toLowerCase() : '';
  }

  function wantsWhitening(value) {
    return /yes|\+\$?65|custom whitening/i.test(String(value || ''));
  }

  function wantsExpedite(value) {
    return /yes|rush|expedite|\+\$?40/i.test(String(value || ''));
  }

  function addonLabel(type) {
    if (type === 'case') return 'Case Color (addon)';
    if (type === 'whitening') return 'Whitening Kit (addon)';
    return 'Expedite Order (addon)';
  }

  function addonTypeForVariant(variantId) {
    var id = toNumber(variantId);
    if (CASE_VARIANT_IDS.indexOf(id) !== -1) return 'case';
    if (id === WHITENING_VARIANT_ID) return 'whitening';
    if (id === EXPEDITE_VARIANT_ID) return 'expedite';
    return '';
  }

  function isAddonLine(item) {
    return !!(item && (addonTypeForVariant(item.variant_id) || item.properties && item.properties._addon_type));
  }

  function formDataToCartPayload(formData) {
    var properties = {};
    var payload = { items: [] };
    var id = formData.get('id');
    var quantity = toNumber(formData.get('quantity')) || 1;

    formData.forEach(function (value, key) {
      var propMatch = key.match(/^properties\[(.+)\]$/);
      if (propMatch) properties[propMatch[1]] = String(value || '');
    });

    if (!id || ADDON_VARIANT_IDS.indexOf(toNumber(id)) !== -1) return null;

    var mainItem = { id: toNumber(id), quantity: quantity, properties: properties };
    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) mainItem.selling_plan = String(sellingPlan);
    var enriched = buildBundledItems([mainItem]);
    if (!enriched || !enriched.items || enriched.items.length <= 1) return null;

    payload.items = enriched.items;
    var sections = formData.get('sections');
    var sectionsUrl = formData.get('sections_url');
    if (sections) payload.sections = String(sections);
    if (sectionsUrl) payload.sections_url = String(sectionsUrl);
    payload._sccAddonGroups = enriched.groupIds;
    return payload;
  }

  function jsonToCartPayload(text) {
    var parsed;
    try {
      parsed = JSON.parse(text);
    } catch (_) {
      return null;
    }

    var sourceItems = Array.isArray(parsed.items) ? parsed.items : [{
      id: parsed.id,
      quantity: parsed.quantity,
      properties: parsed.properties || {},
      selling_plan: parsed.selling_plan
    }];

    var enriched = buildBundledItems(sourceItems);
    if (!enriched || !enriched.groupIds.length) return null;

    parsed.items = enriched.items;
    delete parsed.id;
    delete parsed.quantity;
    delete parsed.properties;
    parsed._sccAddonGroups = enriched.groupIds;
    return parsed;
  }

  function buildBundledItems(sourceItems) {
    var output = [];
    var groupIds = [];

    (sourceItems || []).forEach(function (item) {
      var variantId = toNumber(item && item.id);
      var properties = Object.assign({}, item && item.properties || {});
      var quantity = toNumber(item && item.quantity) || 1;

      output.push(Object.assign({}, item, { id: variantId, quantity: quantity, properties: properties }));

      if (!variantId || ADDON_VARIANT_IDS.indexOf(variantId) !== -1 || properties._addon_type) return;

      var requested = requestedAddonsFromProperties(properties);
      if (!requested.length) return;

      var groupId = properties._scc_addon_group || 'scc-addon-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      properties._scc_addon_group = groupId;
      output[output.length - 1].properties = properties;
      groupIds.push(groupId);

      requested.forEach(function (addon) {
        output.push({
          id: addon.variantId,
          quantity: 1,
          properties: {
            _addon_type: addon.type,
            _addon_label: addonLabel(addon.type),
            _addon_parent_variant_id: String(variantId),
            _scc_addon_group: groupId
          }
        });
      });
    });

    return { items: output, groupIds: groupIds };
  }

  function requestedAddonsFromProperties(properties) {
    var addons = [];
    var caseColor = selectedCaseColorName(properties['Case Color']);
    if (caseColor && CASE_VARIANTS[caseColor]) {
      addons.push({ type: 'case', variantId: CASE_VARIANTS[caseColor] });
    }
    if (wantsWhitening(properties['Add Whitening Kit'])) {
      addons.push({ type: 'whitening', variantId: WHITENING_VARIANT_ID });
    }
    if (wantsExpedite(properties['Expedite Order'])) {
      addons.push({ type: 'expedite', variantId: EXPEDITE_VARIANT_ID });
    }
    return addons;
  }

  function setCheckoutLocked(locked) {
    var buttons = document.querySelectorAll('a[href*="/checkout"],button[name="checkout"],[name="checkout"],[href="/checkout"],[href*="/checkout"]');
    buttons.forEach(function (button) {
      if (button.tagName === 'LINK') return;
      if (locked) {
        if (!button.dataset.sccAddonOriginalText) button.dataset.sccAddonOriginalText = (button.textContent || '').trim();
        if (!button.dataset.sccAddonOriginalDisabled) button.dataset.sccAddonOriginalDisabled = button.disabled || button.hasAttribute('disabled') ? 'true' : 'false';
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('scc-addon-checkout-locked');
        if ('disabled' in button) button.disabled = true;
        if ((button.textContent || '').trim()) button.textContent = 'Updating cart...';
        button.style.pointerEvents = 'none';
      } else {
        button.classList.remove('scc-addon-checkout-locked');
        button.removeAttribute('aria-disabled');
        if (button.dataset.sccAddonOriginalDisabled !== 'true' && 'disabled' in button) button.disabled = false;
        if (button.dataset.sccAddonOriginalText) button.textContent = button.dataset.sccAddonOriginalText;
        button.style.pointerEvents = '';
        delete button.dataset.sccAddonOriginalText;
        delete button.dataset.sccAddonOriginalDisabled;
      }
    });
  }

  function beginPending() {
    pendingCount += 1;
    setCheckoutLocked(true);
  }

  function endPending() {
    pendingCount = Math.max(0, pendingCount - 1);
    if (!pendingCount) setCheckoutLocked(false);
  }

  async function getCart() {
    var response = await nativeFetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function addAddonLine(variantId, parent, type) {
    var body = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          _addon_parent: parent.key,
          _addon_parent_variant_id: String(parent.variant_id),
          _addon_type: type,
          _addon_label: addonLabel(type),
          _scc_addon_group: parent.properties && parent.properties._scc_addon_group || ''
        }
      }]
    };
    await nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function changeLine(item, quantity, properties) {
    await nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: quantity, properties: properties || item.properties || {} })
    });
  }

  function addonBelongsToParent(addon, parent, type, variantId) {
    var props = addon.properties || {};
    if (type && props._addon_type && props._addon_type !== type) return false;
    if (variantId && toNumber(addon.variant_id) !== toNumber(variantId)) return false;
    if (props._addon_parent === parent.key) return true;
    if (props._scc_addon_group && parent.properties && props._scc_addon_group === parent.properties._scc_addon_group) return true;
    return String(props._addon_parent_variant_id || '') === String(parent.variant_id || '');
  }

  function findAddon(cart, parent, addon) {
    return (cart.items || []).find(function (item) {
      return addonBelongsToParent(item, parent, addon.type, addon.variantId);
    });
  }

  function findCartLine(cart, lineId) {
    var id = String(lineId || '');
    return (cart.items || []).find(function (item) {
      return String(item.key || '') === id;
    }) || (cart.items || []).find(function (item) {
      return String(item.variant_id || '') === id;
    });
  }

  function addonStillRequired(cart, addonLine) {
    var type = (addonLine.properties && addonLine.properties._addon_type) || addonTypeForVariant(addonLine.variant_id);
    var variantId = toNumber(addonLine.variant_id);
    if (!type || !variantId) return false;

    return (cart.items || []).some(function (parent) {
      if (!parent || !parent.properties || isAddonLine(parent)) return false;
      return requestedAddonsFromProperties(parent.properties).some(function (addon) {
        if (addon.type !== type || toNumber(addon.variantId) !== variantId) return false;
        var props = addonLine.properties || {};
        if (props._scc_addon_group && parent.properties._scc_addon_group) {
          return props._scc_addon_group === parent.properties._scc_addon_group;
        }
        if (String(props._addon_parent_variant_id || '') === String(parent.variant_id || '')) return true;
        if (props._addon_parent === parent.key) return true;
        return false;
      });
    });
  }

  function parseJsonBody(body) {
    if (typeof body !== 'string') return null;
    try { return JSON.parse(body); } catch (_) { return null; }
  }

  async function maybeBlockRequiredAddonRemoval(input, init) {
    if (!isCartChangeUrl(input) || !isPost(input, init)) return null;
    var parsed = parseJsonBody(init && init.body);
    if (!parsed || toNumber(parsed.quantity) !== 0 || !parsed.id) return null;

    var cart = await getCart();
    var line = findCartLine(cart, parsed.id);
    if (!line || !isAddonLine(line) || !addonStillRequired(cart, line)) return null;

    console.warn('SCC add-on guard blocked removal of a still-required add-on line', {
      id: parsed.id,
      variant_id: line.variant_id,
      properties: line.properties
    });
    return new Response(JSON.stringify(cart), {
      status: 200,
      statusText: 'OK',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  async function finalizeParentLinks(groupIds) {
    if (!groupIds || !groupIds.length) return;
    var cart = await getCart();
    for (var i = 0; i < groupIds.length; i += 1) {
      var groupId = groupIds[i];
      var parent = (cart.items || []).find(function (item) {
        return item.properties && item.properties._scc_addon_group === groupId && !item.properties._addon_type;
      });
      if (!parent) continue;
      var addonLines = (cart.items || []).filter(function (item) {
        return item.properties && item.properties._scc_addon_group === groupId && item.properties._addon_type;
      });
      for (var j = 0; j < addonLines.length; j += 1) {
        var addonLine = addonLines[j];
        var props = Object.assign({}, addonLine.properties || {}, { _addon_parent: parent.key });
        if (addonLine.properties && addonLine.properties._addon_parent === parent.key) continue;
        await changeLine(addonLine, 1, props);
      }
    }
  }

  async function refreshCartUi() {
    if (typeof window.upcartRefreshCart === 'function') {
      try { await window.upcartRefreshCart(); } catch (error) { console.warn('upcartRefreshCart failed', error); }
    }
    document.dispatchEvent(new CustomEvent('scc:addon-cart-synced'));
  }

  async function syncCartAddons() {
    if (syncPromise) return syncPromise;
    syncPromise = (async function () {
      beginPending();
      try {
        for (var pass = 0; pass < 2; pass += 1) {
          var changed = false;
          var cart = await getCart();
          var parents = (cart.items || []).filter(function (item) {
            return item && item.properties && !isAddonLine(item) && requestedAddonsFromProperties(item.properties).length;
          });

          for (var p = 0; p < parents.length; p += 1) {
            var parent = parents[p];
            var requested = requestedAddonsFromProperties(parent.properties);
            for (var r = 0; r < requested.length; r += 1) {
              var addon = requested[r];
              var existing = findAddon(cart, parent, addon);
              if (!existing) {
                await addAddonLine(addon.variantId, parent, addon.type);
                changed = true;
              } else {
                var props = Object.assign({}, existing.properties || {}, {
                  _addon_parent: parent.key,
                  _addon_parent_variant_id: String(parent.variant_id),
                  _addon_type: addon.type,
                  _addon_label: addonLabel(addon.type)
                });
                if (existing.quantity !== 1 || existing.properties && existing.properties._addon_parent !== parent.key) {
                  await changeLine(existing, 1, props);
                  changed = true;
                }
              }
            }
          }

          if (!changed) break;
        }

        var finalCart = await getCart();
        var invalidParents = (finalCart.items || []).filter(function (parent) {
          if (!parent || !parent.properties || isAddonLine(parent)) return false;
          var requested = requestedAddonsFromProperties(parent.properties);
          return requested.some(function (addon) { return !findAddon(finalCart, parent, addon); });
        });
        await refreshCartUi();
        return { ok: invalidParents.length === 0, cart: finalCart, invalidParents: invalidParents };
      } finally {
        endPending();
        syncPromise = null;
      }
    })();
    return syncPromise;
  }

  async function responseWithJson(response, data) {
    return new Response(JSON.stringify(data), {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers
    });
  }

  window.fetch = async function (input, init) {
    var blockedRemoval = await maybeBlockRequiredAddonRemoval(input, init || {});
    if (blockedRemoval) return blockedRemoval;

    if (!isCartAddUrl(input) || !isPost(input, init)) return nativeFetch(input, init);

    var body = init && init.body;
    var payload = null;

    if (body instanceof FormData) {
      payload = formDataToCartPayload(body);
    } else if (typeof body === 'string' && body.trim().charAt(0) === '{') {
      payload = jsonToCartPayload(body);
    }

    if (!payload || !payload._sccAddonGroups || !payload._sccAddonGroups.length) {
      return nativeFetch(input, init);
    }

    var groupIds = payload._sccAddonGroups.slice();
    delete payload._sccAddonGroups;
    beginPending();
    try {
      var nextInit = Object.assign({}, init || {}, {
        method: 'POST',
        headers: Object.assign({}, init && init.headers || {}, { 'Content-Type': 'application/json', Accept: 'application/json' }),
        body: JSON.stringify(payload)
      });
      var response = await nativeFetch(input, nextInit);
      var data;
      try { data = await response.clone().json(); } catch (_) { return response; }
      if (response.ok) {
        await finalizeParentLinks(groupIds);
        await refreshCartUi();
      }
      return responseWithJson(response, data);
    } catch (error) {
      console.error('SCC add-on bundled cart add failed', error);
      throw error;
    } finally {
      endPending();
    }
  };

  async function guardedCheckout(event, explicitTarget) {
    if (checkoutRunning) return;
    var target = explicitTarget || (event.target && event.target.closest ? event.target.closest('a[href*="/checkout"],button[name="checkout"],[name="checkout"],[href="/checkout"],[href*="/checkout"]') : null);
    if (!target || target.tagName === 'LINK') return;

    event.preventDefault();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    checkoutRunning = true;
    beginPending();
    try {
      var result = await syncCartAddons();
      if (result && result.ok) {
        window.location.assign('/checkout');
      } else {
        console.error('SCC checkout blocked: add-on validation failed', result);
        await refreshCartUi();
        alert('We are updating your add-ons. Please review your cart and try checkout again.');
      }
    } catch (error) {
      console.error('SCC checkout blocked: add-on sync failed', error);
      alert('We could not finish updating your add-ons. Please try checkout again.');
    } finally {
      checkoutRunning = false;
      endPending();
    }
  }

  document.addEventListener('click', guardedCheckout, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form) return;
    var submitter = event.submitter;
    if (!(submitter && submitter.matches && submitter.matches('[name="checkout"]')) && !String(form.action || '').includes('/checkout')) return;
    guardedCheckout(event, submitter || form);
  }, true);

  document.addEventListener('cart:updated', syncCartAddons);
  document.addEventListener('upcart:change', syncCartAddons);
  document.addEventListener('upcart:open', function () {
    if (pendingCount) setCheckoutLocked(true);
    syncCartAddons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    setCheckoutLocked(pendingCount > 0);
    syncCartAddons();
  });

  window.SCCAddonCartGuard = {
    sync: syncCartAddons,
    setCheckoutLocked: setCheckoutLocked,
    version: '2026-08-11.3'
  };
})();
